import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
	withStyles,
	Theme,
	createStyles,
	WithStyles,
	Typography,
	Grid,
	Card,
	CardContent,
	Table,
	TableBody,
	TableRow,
	TableCell,
	Avatar,
	Chip,
} from '@material-ui/core';
import {
	NavigateBeforeOutlined as BackIcon,
} from '@material-ui/icons';
import {
	MyPATDialog,
	SearchField,
	MyPATExpansionPanel,
} from '../../common';
import ProfileCard from './ProfileCard';
import ContentCard from './ContentCard';
// import { getTimeAgo } from '../../../utils';
import dateService from '../../common/services/dateService';
import { contentTypeList } from '../../mylibrary/actions/contentTypeActions';
import contentSubtypeActions from '../../mylibrary/actions/contentSubtypeActions';
import UserProfileAction from '../actions/userProfileActions';
import ContentTypeData from '../../mylibrary/types/ContentTypeData';
import UserProfileBody, {
	UserProfileRoles,
	ReviewerReviewees
} from '../types/UserProfileBody';
import UserActivityLog from '../types/UserActivityLog';
import ContentSubtypeData from '../../mylibrary/types/ContentSubtypeData';

const styles = (theme: Theme) => createStyles({
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	mr1x: {
		marginRight: theme.spacing.unit,
	},
	mb2x: {
		marginBottom: theme.spacing.unit * 2,
	},
	textCapitalize: {
		textTransform: 'capitalize',
	},
	cursorPointer: {
		cursor: 'pointer',
	},
	fwNormal: {
		fontWeight: theme.typography.fontWeightRegular,
	},
	cardContentRoot: {
		position: 'relative',
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
	},
	commSeprationLabels: {
		textTransform: 'capitalize',
		marginRight: theme.spacing.unit / 2,
		'&:after': {
			content: '","',
		},
		'&:last-child': {
			marginRight: 0,
			'&:after': {
				display: 'none',
			},
		}
	},

	roleTabs: {
		margin: 0,
		padding: 0,
		display: 'flex',
		alignItems: 'center',

		'& li': {
			...theme.typography.body1,
			flexGrow: 0,
			display: 'inline-block',
			color: theme.palette.text.secondary,
			margin: `0 ${theme.spacing.unit}px`,
			padding: `${theme.spacing.unit / 2}px 0`,
			cursor: 'pointer',
			textTransform: 'capitalize',
			'&.active': {
				color: theme.palette.primary.main,
				textDecoration: 'underline',
			}
		}
	},

	accessPermissionInfo: {
		display: 'inline-block',
		marginLeft: theme.spacing.unit / 2,
		fontWeight: theme.typography.fontWeightRegular,
	},

	accessPermissionTable: {
		width: 'auto',
		'& tr': {
			height: 'auto',
			'& td': {
				fontSize: theme.typography.body1.fontSize,
				border: 0,
				padding: 0,
				paddingTop: theme.spacing.unit / 2,
				paddingBottom: theme.spacing.unit / 2,
				color: theme.palette.text.secondary,
				textTransform: 'capitalize',
				'&:first-child': {
					fontWeight: theme.typography.fontWeightMedium,
					paddingRight: theme.spacing.unit,
					color: theme.palette.text.primary,
				}
			}
		}
	},

	userInfoGrid: {
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: theme.shape.borderRadius,
		marginBottom: theme.spacing.unit,
		padding: theme.spacing.unit,
		'& > div': {
			margin: `0 ${theme.spacing.unit}px`,
		}
	},

	detailsContainer: {
		padding: `${theme.spacing.unit * 2}px 0`,
		marginBottom: theme.spacing.unit * 2,
		borderBottom: `1px solid ${theme.palette.grey[300]}`,
		position: 'relative',
		'&:after': {
			content: '"and"',
			fontFamily: theme.typography.fontFamily,
			position: 'absolute',
			bottom: 0,
			fontSize: '0.8rem',
			padding: `0 ${theme.spacing.unit * 1.5}px`,
			left: '50%',
			transform: 'translateX(-50%) translateY(50%)',
			display: 'inline-block',
			backgroundColor: theme.palette.common.white,
		},
		'&:last-child': {
			borderBottom: 0,
			'&:after': {
				display: 'none',
			}
		}
	},
	breadcrumbList: {
		padding: 0,
		margin: 0,
		'& > li': {
			display: 'inline-block',
			fontFamily: theme.typography.fontFamily,
			fontSize: '0.85rem',
			color: theme.palette.text.primary,
			'&:after': {
				content: '">"',
				margin: `0 ${theme.spacing.unit}px`,
			},
			'&:last-child:after': {
				display: 'none',
			}
		}
	},
	chipsBox: {
		'& > div': {
			marginLeft: theme.spacing.unit,
			height: theme.spacing.unit * 3.5,
			'& > span': {
				fontSize: '0.7rem',
				paddingLeft: theme.spacing.unit * 2,
			},
		}
	},

	seeAllLink: {
		textAlign: 'center',
		'& span': {
			cursor: 'pointer',
			fontWeight: theme.typography.fontWeightRegular,
		}
	},

	backIconRoot: {
		fill: theme.palette.text.secondary,
		fontSize: 24,
		opacity: 0.5,
		marginBottom: 3
	},

	activityAction: {
		color: theme.palette.grey[400],
	},
	activityHours: {
		color: theme.palette.grey[400],
	}
});

interface UserProfileContainerProps extends WithStyles<typeof styles> {
	history: any,
	contentTypes: ContentTypeData[],
	contentSubtypes: ContentSubtypeData[],
	contentTypeList: () => void,
	contentSubtypeList: () => void,
	authenticatedUserId: string,
	getUserProfile: (id: string) => void,
	getActivityLog: (limit: number, pageSkip?:number) => void,
	profileData: UserProfileBody,
	activityLog: UserActivityLog[],
}

interface UserProfileContainerState {
	activeRoleIndex: number,
	allActivityDialogOpen: boolean,
	searchValue: string,
	limit: number,
	scrollPosition: number,
	pageSkip: number,
	
}

class UserProfileContainer extends Component<UserProfileContainerProps, UserProfileContainerState> {
	constructor(props: UserProfileContainerProps) {
		super(props);
		this.state = {
			activeRoleIndex: 0,
			allActivityDialogOpen: false,
			searchValue: '',
			limit: 10,
			pageSkip: 0,
			scrollPosition: 0,
			
		}

		this.handleRoleChange = this.handleRoleChange.bind(this);
		this.handleAllActivityDialogOpen = this.handleAllActivityDialogOpen.bind(this);
		this.handleAllActivityDialogClose = this.handleAllActivityDialogClose.bind(this);
		this.searchChangeHandler = this.searchChangeHandler.bind(this);
		this.listenToActivityScroll = this.listenToActivityScroll.bind(this);
		

		
	}
	
	componentDidMount() {
		
		_.isEmpty(this.props.contentSubtypes) && this.props.contentSubtypeList();
		_.isEmpty(this.props.contentTypes) && this.props.contentTypeList();

		!_.isEmpty(this.props.authenticatedUserId) && this.props.getUserProfile(this.props.authenticatedUserId);
		
		this.props.getActivityLog(2);
		
		
	}

	componentWillReceiveProps(nextProps: UserProfileContainerProps) {
		if (_.isEmpty(this.props.authenticatedUserId)) {
			_.isEmpty(nextProps.profileData) && this.props.getUserProfile(nextProps.authenticatedUserId);
			_.isEmpty(nextProps.activityLog) && this.props.getActivityLog(2);
		}
	}

	handleRoleChange = (activeRoleIndex: number) => this.setState({ activeRoleIndex });

	handleAllActivityDialogOpen = () => {
		let { limit } = this.state;
		this.props.getActivityLog(limit);
		return this.setState({ allActivityDialogOpen: true });
	}

	handleAllActivityDialogClose = () => this.setState({ allActivityDialogOpen: false });

	searchChangeHandler = (evt: any) => this.setState({ searchValue: evt.target.value });

	getActiveReviewers = (activeRoleData: UserProfileRoles, activeMiniLibraryId: string) => {
		let activeReviewers: ReviewerReviewees[] = [];
		_.map(activeRoleData.reviewer, reviewer => _.map(reviewer.roles, role => {
			if (_.isEqual(role.miniLibrary, activeMiniLibraryId)) {
				activeReviewers.push(reviewer);
			}
		}))
		return activeReviewers;
	}

	getActiveReviewees = (activeRoleData: UserProfileRoles, activeMiniLibraryId: string) => {
		let activeReviewees: ReviewerReviewees[] = [];
		_.map(activeRoleData.reviewees, reviewee => _.map(reviewee.roles, role => {
			if (_.isEqual(role.miniLibrary, activeMiniLibraryId)) {
				activeReviewees.push(reviewee);
			}
		}))
		return activeReviewees;
	}

	generateSpan = (label: string, val: any) => <span className={this.props.classes.commSeprationLabels} key={label}>{val} {label}</span>;

	getContentCounts = ({ total: any, ...contentCounts }: any) => {
		let countText: any = [];
		if (_.isEmpty(this.props.contentTypes)) { return '' };
		for (let key in contentCounts) {
			const keyVal = contentCounts[key];
			if (keyVal > 0) {
				const countLabel = _.get(_.find(this.props.contentTypes, ['code', key]), 'name', '');
				countText.push(this.generateSpan(countLabel, keyVal));
			}
		}
		return countText;
	}

	getFormattedContent = () => {
		const { profileData } = this.props;
		let { activeRoleIndex } = this.state;
		let activeDetails = _.get(profileData, `roles[${activeRoleIndex}]`, {});
		let library = _.get(activeDetails, 'miniLibrary', {});
		let formattedContent: any = {};

		const getTypeCodeName = (code: any) => _.get(_.find(this.props.contentTypes, ['code', code]), 'name', '');
		const getSubTypeCodeName = (code: any) => _.get(_.find(this.props.contentSubtypes, ['code', code]), 'name', '');


		for (let type in library.contentMapped) {
			library.contentMapped[type].map((t: any) => {

				t.subjects && t.subjects.map((sD: any, sI: number) => {

					if (_.isEmpty(_.get(sD, 'subSubjects', []))) {
						return;
					}

					sD.subSubjects.map((ssD: any, ssI: number) => {
						ssD.chapters.map((chD: any, chI: number) => {
							chD.concepts.map((coD: any, coI: number) => {
								let key = `${sD.subjectId.name}-${sD.subjectId._id}`;

								if (ssD.subSubjectId) {
									key += `|${coD.classId.name}-${coD.classId._id}|${ssD.subSubjectId.name}-${ssD.subSubjectId._id}`;
								}

								if (!formattedContent[key]) {
									formattedContent[key] = [];
								}

								let data: any = {
									contentType: [],
									count: 0,
								};
								if (type !== 'question') {
									data.contentType.push(getTypeCodeName(t.contentTypeCode));
									data.count = formattedContent[key]['count'] ? formattedContent[key]['count'] + 1 : 1;
								} else {
									data.contentType.push(getSubTypeCodeName(t.contentSubTypeCode));
									data.count = formattedContent[key]['count'] ? formattedContent[key]['count'] + 1 : 1;
								}

								formattedContent[key] = data;
							})
						})
					})
				})
			})
		}

		return formattedContent;
	}

	listenToActivityScroll(e: any){
		let { pageSkip, limit } = this.state;
		const { getActivityLog, activityLog } = this.props;
		
		const dialogElem = document.querySelector('.dialog-content');
		let elem = document.getElementsByClassName('uniqueActivity');
		
		const bounding = elem[elem.length - 1].getBoundingClientRect();
		const scrollPosition:any = dialogElem ? dialogElem.scrollTop : 0;
		
		if(window.innerHeight > bounding.bottom && scrollPosition > this.state.scrollPosition ) 
		//scroll down && 
		{ 
			pageSkip = pageSkip + 1;
			
			getActivityLog( limit,pageSkip );
			this.setState({pageSkip})
		}		
		
		this.setState((state, props) => ({
			scrollPosition
		}));
	}

	render() {

		const { profileData, activityLog, classes, history } = this.props;
		const { activeRoleIndex, allActivityDialogOpen, searchValue } = this.state;
		const activeRoleData: UserProfileRoles = _.get(profileData, `roles[${activeRoleIndex}]`, {});
		const hasActiveRoleData = !_.isEmpty(activeRoleData);

		const activeMiniLibraryId = _.get(activeRoleData, 'miniLibrary._id', '');
		const activeReviewers = this.getActiveReviewers(activeRoleData, activeMiniLibraryId);
		const activeReviewees = this.getActiveReviewees(activeRoleData, activeMiniLibraryId);


		const detailsData = this.getFormattedContent()

		const generateBreadcrumb = (key: string) => {
			const classSubjectSubSubject = key.split('|');
			let breadcrumb: any = '';
			if (classSubjectSubSubject.length > 1) {
				const subject = classSubjectSubSubject[0].split('-');
				const clas = classSubjectSubSubject[1].split('-');
				const subSubject = classSubjectSubSubject[2].split('-');
				breadcrumb = (
					<>
						<li>Class {clas[0]}</li>
						<li>{subject[0]}</li>
						<li>{subSubject[0]}</li>
					</>
				)
			}
			return breadcrumb;
		}

		const selectedContent = () => {
			let data: any = [];
			for (let key in detailsData) {
				data.push(
					<Grid
						key={key}
						container spacing={8} className={classes.detailsContainer}
					>
						<Grid item xs={12}>
							<Typography variant="body1" color="textSecondary">{detailsData[key].count} Selected Content Items In:</Typography>
						</Grid>
						<Grid item xs={12} className={classes.mb1x}>
							<ul className={classes.breadcrumbList}>
								{generateBreadcrumb(key)}
							</ul>
						</Grid>
						<Grid item xs={12} className={classes.chipsBox}>
							{_.map(detailsData[key].contentType, (type: string, i: number) => (
								<Chip key={`chip-${type}-${i}`} label={type} />
							))}
						</Grid>
					</Grid>
				)
			}
			return data;
		}

		return (
			<Grid container alignItems="center" justify="center">
				<Grid item xs={12} md={10} className={classes.mb2x}>
					<ProfileCard userProfile={profileData} />
				</Grid>

				<Grid item xs={12} md={10}>
					<ul className={classes.roleTabs}>
						{_.map(profileData.roles, (role, i) => (
							<li
								key={`role-${i}`}
								className={_.isEqual(activeRoleIndex, i) ? 'active' : ''}
								onClick={this.handleRoleChange.bind(this, i)}
							>
								{_.get(role, 'roleId.role', '')}
							</li>
						))}
					</ul>

					<Card className={classes.mb1x}>
						<CardContent className={classes.cardContentRoot}>
							<Typography variant="h6" className={classes.fwNormal}>
								Access Permission
							</Typography>

							<Table className={classes.accessPermissionTable}>
								<TableBody>
									{hasActiveRoleData && _.map(activeRoleData.roleId.featureLevelPermissions, (permission, i) => (
										permission.accessAllowed.length > 0 && (
											<TableRow key={`permission-${i}`}>
												<TableCell>
													{`${_.toLower(permission.featureType)}:`}
												</TableCell>
												<TableCell>
													Can&nbsp;
													{_.map(permission.accessAllowed, (access, ai) => (
														<span key={`${ai}-access-of-${i}`}
															className={classes.commSeprationLabels}
														>
															{_.toLower(access)}
														</span>
													))}
												</TableCell>
											</TableRow>
										)
									))}
								</TableBody>
							</Table>
						</CardContent>
					</Card>

					<Card className={classes.mb1x}>
						<CardContent className={classes.cardContentRoot}>
							<Typography variant="h6" className={classes.fwNormal} gutterBottom>
								Reviewers ({hasActiveRoleData ? activeReviewers.length : 0})
							</Typography>

							{_.map(activeReviewers, (reviewer, i) => (
								<Grid key={`reviewer-${i}`} container alignItems="center" className={classes.userInfoGrid}>
									<Grid item xs="auto">
										<Avatar alt={`Profile ${reviewer.fullName}`} src={_.isEmpty(reviewer.profileImage) ? "/assets/img/profile-default.png" : reviewer.profileImage} />
									</Grid>
									<Grid item xs>
										<Typography variant="h6" noWrap>{reviewer.fullName}</Typography>
									</Grid>
									<Grid item xs={4}>
										<Typography variant="body1" inline><strong>Role: </strong></Typography>
										<Typography variant="body1" inline>
											{_.get(_.find(reviewer.roles, ['miniLibrary', activeMiniLibraryId]), 'roleId.role', 'not found')}
										</Typography>
									</Grid>
								</Grid>
							))}

						</CardContent>
					</Card>

					<Card className={classes.mb1x}>
						<CardContent className={classes.cardContentRoot}>
							<Typography variant="h6" className={classes.fwNormal} gutterBottom>
								Reviewees ({hasActiveRoleData ? activeReviewees.length : 0})
							</Typography>

							{_.map(activeReviewees, (reviewee, i) => (
								<Grid key={`reviewee-${i}`} container alignItems="center" className={classes.userInfoGrid}>
									<Grid item xs="auto">
										<Avatar alt={`Profile ${reviewee.fullName}`} src={_.isEmpty(reviewee.profileImage) ? "/assets/img/profile-default.png" : reviewee.profileImage} />
									</Grid>
									<Grid item xs>
										<Typography variant="h6" noWrap>{reviewee.fullName}</Typography>
									</Grid>
									<Grid item xs={4}>
										<Typography variant="body1" inline><strong>Role: </strong></Typography>
										<Typography variant="body1" inline className={classes.textCapitalize}>
											{_.get(_.find(reviewee.roles, ['miniLibrary', activeMiniLibraryId]), 'roleId.role', 'not found')}
										</Typography>
									</Grid>
								</Grid>
							))}

						</CardContent>
					</Card>

					<Card className={classes.mb1x}>
						<CardContent className={classes.cardContentRoot}>
							<Typography variant="h6" className={classes.fwNormal}>
								Mini Library
								{hasActiveRoleData && ` : ${_.get(activeRoleData, 'miniLibrary.name', '')}`}
							</Typography>
							<Typography variant="caption" className={classes.mb1x}>
								{hasActiveRoleData && `${_.get(activeRoleData, 'miniLibrary.contentCounts.total', 0)} `}
								Content Items&nbsp;
								{hasActiveRoleData && '('}
								{hasActiveRoleData && this.getContentCounts(_.get(activeRoleData, 'miniLibrary.contentCounts', []))}
								{hasActiveRoleData && ')'}
							</Typography>

							<Grid container spacing={8}>
								<Grid item xs={12}>
									{selectedContent()}

								</Grid>
							</Grid>
						</CardContent>
					</Card>

					<Card>
						<CardContent className={classes.cardContentRoot}>
							<Typography variant="h6" className={classes.fwNormal} gutterBottom>
								Your Activity
							</Typography>
							
								{_.map(activityLog, (log, index) => (index < 2 && !_.isString(log.actionId.elasticContent_id)) && (
									<MyPATExpansionPanel
										key={`log-${index}`}
										defaultExpanded={true}
										hasExpandIcon={false}
										variant="white"
										panelProps={{ className: classes.mb1x }}
										customCollapseTitle={
											<Grid container justify="space-between" alignItems="center">
												<Grid item xs="auto">
													<Typography variant="body1" inline className={`${classes.mr1x} ${classes.textCapitalize}`}>{log.userId.fullName}</Typography>
													<Typography variant="body1" inline className={classes.activityAction}>{log.actionName}</Typography>
												</Grid>
												<Grid item xs="auto">
													<Typography variant="body1" className={classes.activityHours}>{dateService.getTimeAgo(log.createdAt)}</Typography>
												</Grid>
											</Grid>
										}
									> 
										{_.isEqual(log.moduleCode, 'Content') && <ContentCard cardInfo={log.actionId.elasticContent_id} history={history} />}
									</MyPATExpansionPanel>
								))}
							
						</CardContent>
					</Card>

					{(activityLog.length > 1) && (
						<Card className={classes.mb1x}>
							<CardContent className={classes.cardContentRoot}>
								<Typography variant="h6" color="primary" className={classes.seeAllLink}>
									<span onClick={this.handleAllActivityDialogOpen.bind(this)}>See All</span>
								</Typography>
							</CardContent>
						</Card>
					)}
				</Grid>

				<MyPATDialog
					dialogOpen={allActivityDialogOpen}
					otherDialogProps={{ fullScreen: true, onScroll: (e:any) => this.listenToActivityScroll(e) }}
					customDialogTitle={
						<>
							<Grid container justify="space-between" alignItems="center" >
								<Grid item xs="auto">
									<Typography
										color="textPrimary"
										variant="body1"
										className={classes.cursorPointer}
										onClick={this.handleAllActivityDialogClose.bind(this)}
									>
										<BackIcon classes={{ root: classes.backIconRoot }} />
										<strong>Back to Profile</strong>
									</Typography>
								</Grid>
								{/* <Grid item xs={10}>
									<SearchField
										id="activity-search"
										placeholder="Search tags"
										onChange={this.searchChangeHandler.bind(this)}
										value={searchValue}
										fullWidth
									/>
								</Grid> */}
							</Grid>
						</>
					}
					
				>
					
					<Grid container alignItems="center" justify="center" >
						<Grid item xs={12} md={10} className={classes.mb2x}>
							<ProfileCard userProfile={profileData} />
						</Grid >
						<Grid item xs={12} md={10} >
							<Typography variant="h5" className={classes.mb1x}>
								<strong>Your Activity</strong>
							</Typography>
							
							{_.map(activityLog, (log, index) =>
								!_.isString(log.actionId.elasticContent_id) && (
									<MyPATExpansionPanel
										key={`log-${index}`}
										defaultExpanded={true}
										hasExpandIcon={false}
										variant="white"
										panelProps={{ className: classes.mb1x }}
										customCollapseTitle={
											<Grid container justify="space-between" alignItems="center" className={"uniqueActivity"}>
												<Grid item xs="auto">
													<Typography variant="body1" inline className={classes.mr1x}>{log.userId.fullName}</Typography>
													<Typography variant="body1" inline className={classes.activityAction}>{log.actionName}</Typography>
												</Grid>
												<Grid item xs="auto">
													<Typography variant="body1" className={classes.activityHours}>{dateService.getTimeAgo(log.createdAt)}</Typography>
												</Grid>
											</Grid>
										}
									>
										{_.isEqual(log.moduleCode, 'Content') && <ContentCard cardInfo={log.actionId.elasticContent_id} />}
									</MyPATExpansionPanel>
								))}

						</Grid>
						
					</Grid>
					
				</MyPATDialog>
			</Grid>
		);
	}
}

const mapStateToProps = (state: any) => ({
	contentTypes: _.get(state, 'mylibraryData.contentType.list', []),
	contentSubtypes: _.get(state, 'mylibraryData.contentSubtype.list', []),
	authenticatedUserId: _.get(state, 'loginData.userData.authenticatedUser._id', ''),
	profileData: _.get(state, 'userProfileData.userProfile.profile', {}),
	activityLog: _.get(state, 'userProfileData.userProfile.activity', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	contentTypeList,
	contentSubtypeList: contentSubtypeActions.list,
	getUserProfile: UserProfileAction.userProfile,
	getActivityLog: UserProfileAction.activityLog,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserProfileContainer));